export default "__VITE_ASSET__C14Ycqi___"